export default __webpack_public_path__ + "static/media/480_dummy2016-hilfsprojekt01-de-mobile.b3dba4d7.png";